export const MENTION_REGEX = /@\[([^\]]{1,300})\]\(([^)]{1,100})\)/g;

export type MentionSegment =
  | { type: 'text'; text: string }
  | { type: 'mention'; name: string; userId: string };

export const encodeMention = (name: string, userId: string): string => {
  const safeName = name.replace(/[[\]()]/g, '').trim();
  return `@[${safeName}](${userId})`;
};

export const extractMentionedUserIds = (text: string): string[] => {
  const ids = new Set<string>();
  for (const match of text.matchAll(MENTION_REGEX)) {
    const userId = match[2]?.trim();
    if (userId) {
      ids.add(userId);
    }
  }
  return [...ids];
};

export const formatMentionsForDisplay = (text: string): string =>
  text.replace(MENTION_REGEX, (_match, name: string) => `@${name}`);

export const parseMentionSegments = (text: string): MentionSegment[] => {
  const segments: MentionSegment[] = [];
  let lastIndex = 0;

  for (const match of text.matchAll(MENTION_REGEX)) {
    const start = match.index ?? 0;
    if (start > lastIndex) {
      segments.push({ type: 'text', text: text.slice(lastIndex, start) });
    }
    segments.push({ type: 'mention', name: match[1] ?? '', userId: match[2] ?? '' });
    lastIndex = start + match[0].length;
  }

  if (lastIndex < text.length) {
    segments.push({ type: 'text', text: text.slice(lastIndex) });
  }

  return segments;
};
